import { useQuery } from '@tanstack/react-query';
import { fetchJson } from '../lib/api';

export interface Activity {
  id: string;
  type: string;
  description: string;
  entityType?: string;
  entityId?: string;
  entityName?: string;
  userId?: string;
  userName?: string;
  metadata?: Record<string, unknown>;
  createdAt: string;
}

export interface ActivitiesResponse {
  activities: Activity[];
  total: number;
}

export function useActivities(entityType: string, entityId: string | null) {
  return useQuery({
    queryKey: ['activities', entityType, entityId],
    queryFn: () =>
      fetchJson<ActivitiesResponse>(
        `/api/activities?entityType=${entityType}&entityId=${entityId}`,
      ),
    enabled: !!entityId,
  });
}

export function useRecentActivities() {
  return useQuery({
    queryKey: ['activities', 'recent'],
    queryFn: () => fetchJson<ActivitiesResponse>('/api/activities/recent'),
  });
}
